import $ from 'jquery';

class GroupCourseReport {
	constructor(){

		// Check if it's the group course report page
		if (this.isCourseReport()) {
			// Create course report table
			new CourseReportTable();
		}
	}

	isCourseReport(){
		return $( '#group-course-report-datatable' ).length === 1;
	}
}

class CourseReportTable {
	constructor(){

		this.table = null;

		// Get elements
		this.getElements();

		// Listen dropdowns changes
		this.filters();

		// Create DataTable
		this.createDataTables();

		// Populate table after the group course is selected
		this.restPopulateTable();


	}

	getElements(){
		// Get elements
		this.$elements = {
			courseReport: $( '#group-course-report-datatable' ),
			filter: {
				all: $( '.uo-groups-select-filters select' ),
				groupID: $( '#group-id' ),
				courseID: $( '#uo-group-report-course' ),
			}
		}
	}

	filters() {
		// Clear table when one of the filters change
		this.$elements.filter.all.on( 'change', () => {
			// Check if the DataTable is defined
			if ( typeof this.$elements.courseReport === 'undefined' ) {
				return;
			}

			// Try to clear the DataTable
			try {
				// Clear the table
				this.table
					.clear()
					.draw()
					.columns.adjust()
					.responsive.recalc();
			} catch ( e ) {
				// console.warn( e );
			}
		} );

		// Check if there is only one group, and the dropdown is hidden
		if ( this.$elements.filter.groupID.hasClass( 'h3-select' ) ) {
			// Get the group ID
			let groupID = this.$elements.filter.groupID
				.find( 'option:not([value="0"]):not([value=""])' )
				.last()
				.val();

			// Select the first option and trigger the change event
			this.$elements.filter.groupID
				.val( groupID )
				.trigger( 'change' );

			window.ulgmGroupManagement.restForms.sendRestCall( {
				currentTarget: this.$elements.filter.groupID
			} );

			// Disable the dropdown			
			this.$elements.filter.groupID.prop( 'disabled', 'disabled' );
		} else {
			// If there is more than one group, listen changes to clear the "Course" dropdown on change
			this.$elements.filter.groupID.on( 'change', () => {
				// Clear the "Course" group
				this.$elements.filter.courseID
					// Deselect the dropdown, without triggering the change event
					.val( '' )
					// Remove all options
					.find( 'option' )
						.remove();
			} );
		}
	}

	createDataTables(){

		let that       = this;
		let columnDefs = [];

		let columnsVisibility = that.$elements.courseReport.data( 'table_columns' )
		columnsVisibility     = columnsVisibility.split( ',' );

		let columns = [];

		// Check if we have to remove the "Transcript" column
		if ( ! ulgmCourseReportShortcode.shouldAddTranscriptColumn ) {
			// Remove Transcript column
			delete ulgmRestApiSetup.tableColumns.transcript_page_url;
		}

		// Define array with the columns that we're going to send to DataTables
		Object.entries( ulgmRestApiSetup.tableColumns ).forEach( ( [ columnKey, columnName ] ) => {
			columns.push( {
				data: columnKey,
				title: columnName,
				visible: columnsVisibility.includes( columnKey )
			} );
		} );

		// If we have to add the "Transcript" column...
		if ( ulgmCourseReportShortcode.shouldAddTranscriptColumn ) {
			// Get index of the Transcript column
			const transcriptColumnIndex = columns.findIndex( column => column.data == 'transcript_page_url' );

			// ...define the `render` callback to override the column value
			columnDefs = [
				{
					// The `data` parameter refers to the data for the cell (defined by the
					// `data` option, which defaults to the column being worked with, in
					// this case `data: 0`.
					render: function ( data, type, row ){

						return `
							<a 
								href="${ ulgmCourseReportShortcode.transcriptPageURL }?user-id=${ row.user_id }"
								target="_blank"
							>
								${ ulgmRestApiSetup.localized.details }
							</a>
						`;

					},
					targets: transcriptColumnIndex
				}
			]
		}

		let initComplete = ( settings, d ) => {
			try {
				let table = settings.oInstance.api();
				let _this = this;

				var colFilter_container = $( `<div id="${settings.sInstance}-filter-columns" class="dataTables-filter-columns"><input class="dataTables-filter-columns-field" id="${settings.sInstance}-filter-columns-field" type="checkbox"><div class="dataTables-filter-columns__toggle"><label for="${settings.sInstance}-filter-columns-field" data-label-enable="${ulgmRestApiSetup.localized.customizeColumns}" data-label-disable="${ulgmRestApiSetup.localized.hideCustomizeColumns}"></label></div><div class="dataTables-filter-columns__fields"></div></div>` );

				// DataTables 2.x uses different property structure
				// First try DataTables 2.x structure
				if (settings.aoColumns) {
					jQuery.each(settings.aoColumns, function (key, value) {
						if (key > 0) {
							var title = value.sTitle;
							var visible = value.bVisible;
							colFilter_container.find('.dataTables-filter-columns__fields').append(_this.addColumnCourseCheckbox(title, key, visible, table));
						}
					});
				} 
				// Fallback to saved state if available
				else if (settings.oSavedState && settings.oSavedState.columns) {
					jQuery.each(settings.oSavedState.columns, function (key, value) {
						if (key > 0) {
							// Find the column title from the table header
							var title = jQuery('#group-course-report-datatable th').eq(key).text();
							var visible = value.visible;
							colFilter_container.find('.dataTables-filter-columns__fields').append(_this.addColumnCourseCheckbox(title, key, visible, table));
						}
					});
				}
				// As a last resort, get columns directly from API
				else if (table) {
					var columns = table.settings().init().columns;
					jQuery.each(columns, function (key, value) {
						if (key > 0) {
							var title = value.title;
							var visible = value.visible !== false;
							colFilter_container.find('.dataTables-filter-columns__fields').append(_this.addColumnCourseCheckbox(title, key, visible, table));
						}
					});
				}

				// Insert after search box
				var $searchBox = jQuery('.dt-search');
				if ($searchBox.length > 0 && colFilter_container.length > 0) {
					colFilter_container.insertAfter($searchBox);
				} else {
					// Fallback - insert at the end of the datatable header
					colFilter_container.appendTo('.uo-groups-datatable-header');
				}

				// Ensure column visibility toggles are working with DataTables 2.x
				jQuery('.dataTables-filter-columns input[type="checkbox"]').on('change', function() {
					var columnIndex = jQuery(this).attr('id').replace('dt_', '');
					var column = table.column(columnIndex);
					var isChecked = jQuery(this).is(':checked');
					
					column.visible(isChecked);
				});

				// Add a class to make the customize columns UI visible
				setTimeout(function() {
					jQuery('.dataTables-filter-columns').addClass('dt-initialized');
				}, 100);

			} catch (error) {
				console.error('Error in initComplete:', error.message);
			}
		};

		var buttonCommon = {
			exportOptions: {
				columns: ( id, data, node ) => {
                    return this.table.column( id ).visible();
                },

				format: {
					body: function (data, row, column, node) {
						// Strips hidden timestamp <span>
						return data.replace(/\<span\s(?:class\=\"ulg\-hidden\-data\")(.*)\<\/span\>/g, '');
					}
				}
			},
			filename: function () {
				let courseNamePrefix = 'Groups-Course-Report';
				let $courseId = $('#uo-group-report-course').val();
				let courseName = '-' + $("#uo-group-report-course option:selected").text();
				let name = '';
				if (typeof that.getUrlParameter('user_id') !== 'undefined') {

					name = that.$elements.courseReport.data('user_name');

					if (isNaN(name)) {
						name = '-for-user-' + name;
					} else {
						name = '-for-user-id-' + name;
					}

					return courseNamePrefix + name;

				} else if ('0' === $courseId) {
					return courseNamePrefix;
				}

				return courseNamePrefix + courseName;
			}
		};

		// Check what column has to be used to sort the table
		let tableOrder = [];
		// Find the index of the column we have to use to sort
		let tableOrderByIndex = columns.findIndex( columnData => columnData.title == ulgmCourseReportShortcode.table.orderBy );

		// If the column doesn't exist, then try to get the default one
		if ( tableOrderByIndex === -1 ) {
			tableOrderByIndex = columns.findIndex( columnData => columnData.data == 'date_completed' );
		}
		// If the one defined by the user, or the default one exists, add it
		if ( tableOrderByIndex !== -1 ) {
			tableOrder = [
				[
					tableOrderByIndex, // The ID of the column used to sort, defaults to `date_completed`
					ulgmCourseReportShortcode.table.order, // Designates the ascending or descending order of the 'orderby' parameter, defaults to `desc`
				]
			];
		}

		let exportButtons = [];
		if ( ulgmCourseReportShortcode.showCSVExportButton ) {
			exportButtons.push( $.extend(true, {}, buttonCommon, {
				extend: 'csv',
				text: ulgmRestApiSetup.i18n.exportCSV,
			}) );
		}
		if ( ulgmCourseReportShortcode.showExcelExportButton ) {
			exportButtons.push( $.extend(true, {}, buttonCommon, {
				extend: 'excelHtml5',
				text: ulgmRestApiSetup.i18n.exportExcel,
			}) );
		}

		// Check for existing DataTable and properly destroy it
		if ($.fn.DataTable.isDataTable('#group-course-report-datatable')) {
			$('#group-course-report-datatable').DataTable().destroy();
		}

		// User table
		try {
			// Remove problematic properties for DataTables 2.x
			if (tableVars && tableVars.headerRows !== undefined) {
				delete tableVars.headerRows;
			}

			// Add ColReorder to the configuration
			const tableVars = {
				stateSave: true,
				stateLoadParams: function (settings, data) {
					// If there's saved state data and columns don't match current configuration
					if (data && data.columns && data.columns.length !== columns.length) {
						// Clear the saved state using the settings API.
						$.fn.dataTable.Api(settings).state.clear();
						
						return false;
					}
				},
				initComplete: initComplete,
				dom: '<"uo-groups-datatable-header"B>frt<"uo-groups-datatable-footer"lpi>',
				buttons: exportButtons,
				order: tableOrder,
				columns: columns,
				columnDefs: columnDefs,
				colReorder: {
					enable: true,
					fixedColumnsLeft: 1  // Keep checkbox column fixed
				},
				language: {
					processing: ulgmRestApiSetup.localized.processing,
					search: '_INPUT_',
					searchPlaceholder: ulgmRestApiSetup.localized.searchPlaceholder,
					lengthMenu: ulgmRestApiSetup.localized.lengthMenu,
					info: ulgmRestApiSetup.localized.info,
					infoEmpty: ulgmRestApiSetup.localized.infoEmpty,
					infoFiltered: ulgmRestApiSetup.localized.infoFiltered,
					infoPostFix: '',
					loadingRecords: ulgmRestApiSetup.localized.loadingRecords,
					zeroRecords: ulgmRestApiSetup.localized.zeroRecords,
					emptyTable: ulgmRestApiSetup.localized.emptyTable,
					paginate: {
						first: ulgmRestApiSetup.localized.paginate.first,
						previous: ulgmRestApiSetup.localized.paginate.previous,
						next: ulgmRestApiSetup.localized.paginate.next,
						last: ulgmRestApiSetup.localized.paginate.last
					},
					aria: {
						sortAscending: ulgmRestApiSetup.localized.sortAscending,
						sortDescending: ulgmRestApiSetup.localized.sortDescending
					}
				}
			};

			this.table = this.$elements.courseReport.DataTable(tableVars);

			// Verify ColReorder is available
			if (!jQuery.fn.dataTable.ColReorder) {
				console.warn('ColReorder extension not available despite being configured');
			}

		} catch (error) {
			console.error('Error initializing DataTable:', error.message);
			
			// Try with minimal configuration
			try {
				this.table = this.$elements.courseReport.DataTable({
					responsive: true,
					columns: columns
				});
			} catch (fallbackError) {
				console.error('Fallback initialization failed:', fallbackError.message);
			}
		}
	}

	addColumnCourseCheckbox( label, column_key, is_visible, table ){

		var checkbox = jQuery( '<input />', {
			type: 'checkbox',
			id: 'dt_' + column_key,
			value: column_key,
			checked: is_visible
		} );

		checkbox.on( 'change', function ( e ){
			// Get the column API object
			var current_check = jQuery( this ).attr( 'value' );
			var is_checked    = jQuery( this ).is( ':checked' );

			table.columns().every( function ( index ){

				var column = table.column( index );

				// ... do something with data(), or this.nodes(), etc

				if (index == current_check) {
					if (is_checked) {
						// Toggle the visibility
						column.visible( true );
					} else {
						column.visible( false );
					}
				}


			} );

		} );

		var $label = jQuery( '<label/>' ).append( checkbox ).append( label );
		return $label;
	}

	restPopulateTable(){

		let that                                       = this;
		window.ulgmGroupManagement.populateReportTable = function ( data ){

			let courseReport = that.$elements.courseReport.DataTable();

			courseReport.clear().draw();
			courseReport.rows.add( data.user_course_data ); // Add new data
			courseReport.columns.adjust().draw(); // Redraw the DataTable
			courseReport.responsive.recalc();

			var items = window.ulgmGroupManagement.reportingTemplating.items = data.user_course_data;

			if (0 === items.length) {
				$( '#test' ).html( '<div class="uo-row uo-table-content uo-tbl-item body-row"><div class="uo-table-no-results">There are no records to display.</div></div>' );
			} else {
				$( '#test' ).closest( '.uo-groups-rest-result' ).show();
				window.ulgmGroupManagement.reportingTemplating.setItems( items );
			}
		};
	}

	getUrlParameter( sParam ){
		let sPageURL      = window.location.search.substring( 1 ),
			sURLVariables = sPageURL.split( '&' ),
			sParameterName,
			i;

		for (i = 0; i < sURLVariables.length; i++) {
			sParameterName = sURLVariables[i].split( '=' );

			if (sParameterName[0] === sParam) {
				return sParameterName[1] === undefined ? true : decodeURIComponent( sParameterName[1] );
			}
		}
	}
}

export default GroupCourseReport;
